import React, { Component } from 'react';
import { BackButton, Sharing, ContentHeader } from 'C4';

export default class TemplateView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 'EX_newsletter',
      textBox1: '',
      textBox2: '',
      templateURL: 'https://cms.travpromobile.com/lacoleccion/EX_newsletter.jpeg',
    };
  }

  handleTextBox1Change = (e) => {
    this.setState({ textBox1: encodeURI(e.target.value) });
  };

  handleTextBox2Change = (e) => {
    this.setState({ textBox2: encodeURI(e.target.value) });
  };

  clearText = () => {
    this.setState({
      textBox1: '',
      textBox2: '',
      templateURL: `https://cms.travpromobile.com/lacoleccion/${this.state.selected}.jpeg`,
    });
  };

  loadTemplate = (image) => {
    this.setState({
      templateURL: `https://cms.travpromobile.com/lacoleccion/index.php?template=${image}&field1=${this.state.textBox1}&field2=${this.state.textBox2}`,
      selected: image,
    });
  };

  submitText = () => {
    this.setState({
      templateURL: `https://cms.travpromobile.com/lacoleccion/index.php?template=${this.state.selected}&field1=${this.state.textBox1}&field2=${this.state.textBox2}`,
    });
  };

  render() {
    const { templateURL, textBox1, textBox2 } = this.state;
    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get('mobile')) {
      mobile = true;
    }
    
    return (
      <div className="contentContainer">
        <ContentHeader header="Templates" subtitle="Travel advisors, use this area to create and send your own personalized newsletter to your clients with you as the call to action!" />
        <div className="mainGrid">
          <div className="leftSide">
            <div className="selectedCard">
              <div>
                <a
                  data-fancybox={templateURL}
                  data-src={templateURL}
                  href={templateURL}
                  key={templateURL}
                >
                  <img src={templateURL} alt="template" on />
                </a>
              </div>
            </div>
          </div>
          <div className="rightSide">
            <div>
              <h6>Step 1: Choose a Template</h6>
              <button type="button" onClick={() => this.loadTemplate('EX_newsletter')}>
                The Explorean
              </button>
              <button type="button" onClick={() => this.loadTemplate('CU_newsletter')}>
                Curamoria
              </button>
              <button type="button" onClick={() => this.loadTemplate('FA_newsletter')}>
                Fiesta Americana
              </button>
              <button type="button" onClick={() => this.loadTemplate('GFA_newsletter')}>
                Grand Fiesta Americana
              </button>
              <button type="button" onClick={() => this.loadTemplate('LA_newsletter')}>
                Live Aqua
              </button>
            </div>
            <div>
              <h6>Step 2: Type your personalized text</h6>
              <form>
                <textarea
                  name="text1"
                  id="text1"
                  placeholder="Your personal message here..."
                  onChange={this.handleTextBox1Change}
                  multiline="true"
                />
                <br />
                <textarea
                  name="text2"
                  id="text2"
                  placeholder="Your contact information here..."
                  onChange={this.handleTextBox2Change}
                  multiline="true"
                />
                <br />
                <div className="buttonGridForm">
                  <button type="button" id="clear" onClick={() => this.clearText()}>
                    Clear
                  </button>
                  <button type="button" id="submit" onClick={() => this.submitText()}>
                    Submit
                  </button>
                </div>
              </form>
            </div>
            <div className="rightSide__social">
              <h6>Step 3: Share your card</h6>
              <Sharing url={templateURL} type="template" />
            </div>
            {mobile && (
          <style>
            {
              '\
         .backLink { display: none !important; } .cookieConsent { display: none !important; } .listContainer { height: calc(100vh - 8rem) !important; } .search { width: 100% !important; } .header { display: none !important; } .contentContainer { margin-top: 5rem !important; }'
            }
          </style>
        )}
          </div>
        </div>
      </div>
    );
  }
}
